var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',{attrs:{"size":"lg"},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('b-input-group-text',[_c('i',{staticClass:"fad fa-font-case"})])]},proxy:true}])},[_c('b-form-input',{on:{"keyup":_vm.typed},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }